import { DateTime } from "luxon";
import { confirmAlert } from "react-confirm-alert";
import { Trans } from "react-i18next";

export const getLocalDate = (value, timezone) => {
  return DateTime.fromISO(value, { zone: timezone }).toFormat("dd MMMM yyyy");
};

export let defaultAlertMessages = {
  TittleError: <Trans>ERROR</Trans>,
  TittleWarning: <Trans>Dikkat</Trans>,
  TittleSuccess: <Trans>Başarılı</Trans>,
  MessageDetailError: <Trans>please_try_again</Trans>,
  MessageDetailWarning: <Trans>sure_continue</Trans>,
  MessageDetailSuccess: <Trans>successfully_completed</Trans>,
  Ok: <Trans>Tamam</Trans>,
  Yes: <Trans>Evet</Trans>,
  No: <Trans>Hayır</Trans>,
};

export const serviceMessageSuccess = (message) => {
  defaultAlertMessages.MessageDetailSuccess = message;
  confirmAlert({
    customUI: ({ onClose }) => {
      return getConfirmSuccessMessage(onClose, defaultAlertMessages);
    },
  });
};

export const serviceMessageError = (message) => {
  defaultAlertMessages.MessageDetailError = message;
  confirmAlert({
    customUI: ({ onClose }) => {
      return getConfirmErrorMessage(onClose, defaultAlertMessages);
    },
  });
};

export const getConfirmErrorMessage = (onClose, objMessageInfo) => {
  return (
    <div className="eConfirm">
      <div className="circle-wrapper">
        <div className="error circle"></div>
        <div className="error-icon icon">
          <i className="fa fa-times"></i>
        </div>
      </div>
      <h2 className="text-center">{objMessageInfo.TittleError}</h2>
      <hr></hr>
      <p>{objMessageInfo.MessageDetailError}</p>
      <div className="eConfirmButtons text-center">
        <button className="k-button btn-primary w-50" onClick={onClose}>
          {objMessageInfo.Ok}
        </button>
      </div>
    </div>
  );
};

export const getConfirmSuccessMessage = (onClose, objMessageInfo) => {
  return (
    <div className="eConfirm">
      <div className="circle-wrapper">
        <div className="success circle"></div>
        <div className="success-icon  icon">
          <i className="fa fa-check"></i>
        </div>
      </div>
      <h2 className="text-center">{objMessageInfo.TittleSuccess}</h2>
      <hr></hr>
      <p>{objMessageInfo.MessageDetailSuccess}</p>
      <div className="eConfirmButtons text-center">
        <button className="k-button btn-success w-50" onClick={onClose}>
          {objMessageInfo.Ok}
        </button>
      </div>
    </div>
  );
};

export const getConfirmWarningMessage = (
  onClose,
  handleYesClick,
  objMessageInfo,
  objData
) => {
  return (
    <div className="eConfirm">
      <div className="circle-wrapper">
        <div className="warning circle"></div>
        <div className="warning-icon icon">
          <i className="fa fa-exclamation"></i>
        </div>
      </div>
      <h2 className="text-center">{objMessageInfo.TittleWarning}</h2>
      <hr></hr>
      <p>{objMessageInfo.MessageDetailWarning}</p>
      <div className="eConfirmButtons text-center">
        <button
          className="k-button btn-primary w-50"
          onClick={() => {
            handleYesClick(objData);
            onClose();
          }}
        >
          {objMessageInfo.Yes}
        </button>
        <button className="k-button btn-danger w-50" onClick={onClose}>
          {objMessageInfo.No}
        </button>
      </div>
    </div>
  );
};

export function generateTimeBasedId() {
  return `id-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
}
